// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Storefront20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Storefront20CircleFilled: FC<Storefront20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm7-6.508V11.5c.444-.333.73-.75.854-1.25.125-.5.125-1.028 0-1.583L18.896 6c-.084-.361-.247-.618-.49-.77-.243-.154-.543-.23-.9-.23H6.494c-.356 0-.66.083-.91.25-.25.167-.41.417-.479.75l-.958 2.667a3.486 3.486 0 0 0-.01 1.583c.117.5.406.91.864 1.23v6.02c0 .403.147.753.44 1.052.294.299.647.448 1.06.448h11a1.44 1.44 0 0 0 1.06-.443c.293-.295.44-.65.44-1.064Zm-4.427-7.284a1.024 1.024 0 0 1-.74.292.964.964 0 0 1-.708-.292.973.973 0 0 1-.292-.716V6.5h1.5l.5 3a.824.824 0 0 1-.26.708Zm-3.698 0a.977.977 0 0 1-.719.292c-.285 0-.528-.097-.729-.292a.824.824 0 0 1-.26-.708l.5-3h1.5v2.992a.974.974 0 0 1-.292.716Zm-3.719.063c-.187.153-.406.229-.656.229a.93.93 0 0 1-.813-.427.965.965 0 0 1-.125-.906L6.5 6.5H8l-.52 3.188a.856.856 0 0 1-.324.583Zm11.167-.198a.956.956 0 0 1-.823.427c-.236 0-.451-.076-.646-.23a.843.843 0 0 1-.333-.582L16 6.5h1.5l.958 2.667a.95.95 0 0 1-.135.906ZM6.51 17.5H6.5V12c.32 0 .628-.06.927-.182.298-.12.6-.331.906-.63.264.305.549.517.854.635.306.118.632.177.98.177.347 0 .68-.07 1-.208.32-.14.597-.34.833-.604.264.263.548.465.852.604.305.139.632.208.981.208.351 0 .682-.066.993-.198.31-.132.59-.337.84-.614.25.277.532.482.844.614.313.132.643.198.99.198v5.5H6.51Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Storefront20CircleFilled;
